import { c as _c } from "react/compiler-runtime";
import { useCountries } from "@/hooks/useCountries";
import { faArrowLeft, faRightFromBracket, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HeaderActions, type ProfileSection } from "@xefi/x-react/templates";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { useRouter } from "next/navigation";
import { UserModel } from "../../domain/models/User";
import { useEffect } from "react";
import { useUserStore } from "@/store/useUserStore";
import { authService } from "../../services/AuthService";
const profileSections = (router: AppRouterInstance, userName: string, setCurrentUser: (user: UserModel | null) => void): ProfileSection[] => [{
  key: "profile",
  showDivider: false,
  title: userName,
  actions: [{
    key: "form",
    label: "Retour",
    icon: <FontAwesomeIcon icon={faArrowLeft} className="size-4" />,
    onClick: () => {
      window.location.href = `${process.env.NEXT_PUBLIC_PORTAIL_URL}`;
    }
  }, {
    key: "logout",
    label: "Déconnexion",
    icon: <FontAwesomeIcon icon={faRightFromBracket} className="size-4" />,
    onClick: () => {
      setCurrentUser(null);
      authService.logout();
    }
  }]
}];
export const FluxHeader = t0 => {
  const $ = _c(24);
  const {
    currentUser
  } = t0;
  const router = useRouter();
  const {
    languages,
    currentLanguage,
    changeLanguage
  } = useCountries();
  const {
    setCurrentUser
  } = useUserStore();
  const userName = currentUser ? `${currentUser.firstname ?? ""} ${currentUser.lastname ?? ""}`.trim() : "Chargement...";
  let t1;
  let t2;
  if ($[0] !== currentUser || $[1] !== setCurrentUser) {
    t1 = () => {
      if (!currentUser) {
        return;
      }
      setCurrentUser(currentUser);
    };
    t2 = [currentUser, setCurrentUser];
    $[0] = currentUser;
    $[1] = setCurrentUser;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = currentLanguage || "fr";
  let t4;
  if ($[4] !== t3) {
    t4 = new Set([t3]);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const selectedLanguage = t4;
  const T0 = HeaderActions;
  const t5 = currentUser ? profileSections(router, userName, setCurrentUser) : [];
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      variant: "bordered",
      classNames: {
        trigger: "px-4 h-10"
      }
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== changeLanguage) {
    t7 = keySet => {
      const newLanguage = Array.from(keySet)[0] as string;
      if (newLanguage) {
        changeLanguage(newLanguage);
      }
    };
    $[7] = changeLanguage;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: "size-6"
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== currentUser?.firstname) {
    t9 = currentUser?.firstname?.charAt(0);
    $[10] = currentUser?.firstname;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== currentUser?.lastname) {
    t10 = currentUser?.lastname?.charAt(0);
    $[12] = currentUser?.lastname;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = `https://ui-avatars.com/api/?name=${t9}+${t10}`;
  let t12;
  if ($[14] !== t11 || $[15] !== userName) {
    t12 = {
      name: userName,
      classNames: t8,
      avatarSrc: t11
    };
    $[14] = t11;
    $[15] = userName;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== T0 || $[18] !== languages || $[19] !== selectedLanguage || $[20] !== t12 || $[21] !== t5 || $[22] !== t7) {
    t13 = <T0 profileSections={t5} profileDropdownProps={t6} selectedLanguage={selectedLanguage} onLanguageChange={t7} i18nIsDynamicList={true} gap="4" user={t12} languages={languages} />;
    $[17] = T0;
    $[18] = languages;
    $[19] = selectedLanguage;
    $[20] = t12;
    $[21] = t5;
    $[22] = t7;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};